module.exports = __webpack_public_path__ + "img/vertical_7_6_3.332f863d.png";